<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Turmas</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
          <v-btn text color="primary" @click="modalFilter = true">
            <v-icon left>mdi-filter-outline</v-icon> Filtrar
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'celebrationFormNew' }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
        :sort-by.sync="pagination.sortBy"
        :sort-desc.sync="pagination.sortDesc"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'celebrationDetails', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
          <v-btn :to="{ name: 'celebrationForm', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.description="{ item }">
          {{ (item.description && item.description.length > 33) ? item.description.substr(0,30) + '...' : item.description }}
        </template>
        <template v-slot:item.balance="{ item }">
          {{ item.balance | price }}
        </template>
        <template v-slot:item.step="{ item }">
          <v-chip v-if="item.step === -1" class="ml-sm-2" small color="mute">Finalizada</v-chip>
          <v-chip v-else-if="item.step === 0 && item.activate" class="ml-sm-2" small color="success">Ativa</v-chip>
          <v-chip v-else-if="item.step === 0" class="ml-sm-2" small color="secondary">Desabilitada</v-chip>
          <v-chip v-else class="ml-sm-2" small color="warning">Incompleta - Passo {{ item.step }}</v-chip>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
        <template v-slot:item.event_date="{ item }">
          {{ item.event_date | moment('DD/MM/YYYY') }}
        </template>
      </v-data-table>
    </v-container>
    <filter-modal :open="modalFilter" page="celebrations" title="Turmas" @close="modalFilter = false"></filter-modal>
  </v-main>
</template>

<script>
import axios from 'axios'
import FilterModal from '@/components/FilterModal'
import Quicksearch from '@/components/Quicksearch'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'celebrations',
  components: {
    Quicksearch,
    FilterModal
  },
  data: () => ({
    loading: false,
    modalFilter: false,
    quicksearch: '',
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        value: 'name'
      },
      {
        text: 'Convite',
        sortable: false,
        value: 'description'
      },
      {
        text: 'Código',
        sortable: false,
        value: 'code'
      },
      {
        text: 'Etapa',
        sortable: false,
        value: 'step'
      },
      // {
      //   text: 'Saldo',
      //   sortable: false,
      //   value: 'balance'
      // },
      {
        text: 'Criado em',
        value: 'created_at'
      },
      {
        text: 'Data do evento',
        value: 'event_date'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    }
  }),
  computed: {
    ...mapGetters(['searchParams']),
    noResultText () {
      return 'Nenhuma turma cadastrada'
    },
    params () {
      let params = '?page[size]=' + this.pagination.rowsPerPage + '&page[number]=' + this.pagination.page
      if (this.quicksearch.length > 0) params += '&filter[q]=' + this.quicksearch
      for (let key in this.searchParams('celebrations')) {
        if (this.searchParams('celebrations')[key]) {
          if (key === 'step') {
            const options = this.searchParams('celebrations')[key]
            // activate
            if ((options.includes('incomplete') || options.includes('inactive')) && !options.includes('active') && !options.includes('ended')) {
              params += '&filter[activate]=false'
            } else if (options.includes('active') && !options.includes('incomplete') && !options.includes('inactive')) {
              params += '&filter[activate]=true'
            }
            // step
            const steps = []
            if (options.includes('inactive') || options.includes('active')) steps.push(0)
            if (options.includes('ended')) steps.push(-1)
            if (options.includes('incomplete')) { steps.push(1); steps.push(2); steps.push(3) }
            if (steps.length > 0) params += '&filter[step]=' + steps.join()
          } else if (Array.isArray(this.searchParams('celebrations')[key])) {
            params += '&filter[' + key + ']=' + this.searchParams('celebrations')[key].join()
          } else {
            params += '&filter[' + key + ']=' + this.searchParams('celebrations')[key]
          }
        }
      }
      for (let i = 0, l = this.pagination.sortBy.length; i < l; i++) {
        if (i === 0) params += '&sort='
        else params += ','
        if (this.pagination.sortDesc[i]) params += '-'
        params += this.pagination.sortBy[i]
      }
      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    ...mapMutations(['SET_SEARCH_PARAMS']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('celebrations' + vue.params)
        .then(response => {
          vue.items = response.data.data
          vue.loading = false
          vue.pagination.total = response.data.meta.total
        })
        .catch(() => {
          vue.loading = false
          vue.items = []
          vue.pagination.total = 0
        })
    }
  },
  created () {
    this.SET_SEARCH_PARAMS({ page: 'celebrations', params: { step: ['active', 'inactive', 'incomplete'] } })
    this.getData()
  }
}
</script>
